import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, IconComponent } from '@sc/ui-components';
import { TourService, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'sc-product-tour',
  styleUrls: ['./product-tour.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TourStepTemplateComponent,
    IconComponent,
    MatCardModule,
    NgIf,
    ButtonComponent,
    TranslateModule,
  ],
  template: `
    <tour-step-template>
      <ng-template let-step="step">
        <div class="tour-step-template-custom">
          <sc-icon class="dot" name="tour_dot"></sc-icon>
          <mat-card
            appearance="outlined"
            class="card"
            (click)="$event.stopPropagation()"
          >
            <mat-card-header>
              <mat-card-title class="sc-design-text-1">
                {{ step?.title }}
              </mat-card-title>
              <button
                mat-icon-button
                class="btn-close"
                (click)="tourService.end()"
              >
                <sc-icon name="close"></sc-icon>
                <span class="sr_only">{{
                  'GlobalApplicativeConstants.accessibility.closeDialog'
                    | translate: { dialogTitle: undefined }
                }}</span>
              </button>
            </mat-card-header>
            <mat-card-content class="sc-design-text-3">
              {{ step?.content }}
            </mat-card-content>
            <mat-card-actions>
              <div class="prev-next-btns-container">
                <sc-button
                  *ngIf="tourService.hasPrev(step)"
                  class="product-tour-previous-button product-tour-navigation"
                  buttonType="secondary"
                  leftIcon="arrow_left"
                  (click)="tourService.prev()"
                >
                  {{
                    'GlobalApplicativeConstants.productTour.actions.previous'
                      | translate
                  }}
                </sc-button>
                <sc-button
                  *ngIf="tourService.hasNext(step)"
                  [class.product-tour-next-button]="tourService.hasNext(step)"
                  class="product-tour-navigation"
                  buttonType="secondary"
                  rightIcon="arrow_right"
                  (click)="tourService.next()"
                >
                  {{
                    'GlobalApplicativeConstants.productTour.actions.next'
                      | translate
                  }}
                </sc-button>
              </div>
              <sc-button
                *ngIf="tourService.hasNext(step)"
                class="product-tour-skip-button"
                buttonType="mainWhite"
                (click)="tourService.end(); productTourEnd()"
              >
                {{
                  'GlobalApplicativeConstants.productTour.actions.skip'
                    | translate
                }}
              </sc-button>
              <sc-button
                *ngIf="!tourService.hasNext(step)"
                class="product-tour-next-button"
                (click)="tourService.end(); productTourEnd()"
              >
                {{
                  'GlobalApplicativeConstants.productTour.actions.end'
                    | translate
                }}
              </sc-button>
            </mat-card-actions>
          </mat-card>
        </div>
      </ng-template>
    </tour-step-template>
  `,
})
export class ProductTourComponent {
  @Output() tourEnd: EventEmitter<void> = new EventEmitter<void>();

  constructor(public tourService: TourService) {}

  productTourEnd() {
    this.tourEnd.emit();
  }
}
